import M_SearchItem from '@/components/M_Molecules/M_SearchItem/M_SearchItem';
import styles from './O_SearchResults.module.css';
import { User } from '@/types';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface O_SearchResultsProps {
  results: User[];
  query: string;
  onUserSelect?: (user: User) => void;
}

export default function O_SearchResults({
  results,
  query,
  onUserSelect,
}: O_SearchResultsProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div className={styles.wrapper}>
      <div className={styles.search_caption}>
        <span className={cn(styles.search_caption_text, 'text-p-7')}>
          {t('inviteCoauthors.searchMatches')}
        </span>
      </div>
      <div className={styles.results_wrapper}>
        {results.map(result => (
          <M_SearchItem
            key={result.id}
            user={result}
            query={query}
            onClick={() => onUserSelect?.(result)}
          />
        ))}
      </div>
    </div>
  );
}
